import type { Config } from './types/config';

export const CONFIG: Readonly<Config> = Object.freeze({
    CRT_SUPPORT_BS: true,
});
